import { render } from "./RegistrationInfoForm.vue?vue&type=template&id=f6358d00&scoped=true"
import script from "./RegistrationInfoForm.vue?vue&type=script&lang=js"
export * from "./RegistrationInfoForm.vue?vue&type=script&lang=js"

import "./RegistrationInfoForm.vue?vue&type=style&index=0&id=f6358d00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6358d00"]])

export default __exports__